
export const FAQS = [
    {
      question: 'What is Click by Paymob?',
      answer:
        "Click by Paymob is Paymob's 1-Click Checkout solution. It allows you to create a secure account during checkout, save your card details and addresses, and enjoy faster, frictionless payments across any merchant using Paymob.",
    },
    {
      question: 'How do I Sign Up for Click by Paymob?',
      answer:
        'You can sign up for Click by Paymob in two ways: through Paymob’s Checkout or via the Click Customer Portal.\nTo create an account, simply provide your email address and mobile number. After that, you’ll need to verify your account using a one-time password (OTP) sent to your mobile number.',
    },
    {
      question: 'How do I Sign In to my Click by Paymob account?',
      answer:
        'To sign in to your Click by Paymob account, enter your email address. You’ll receive a one-time password (OTP) on your registered mobile number, or you can choose to receive the OTP via email.\nIf you’ve set up a passkey, you can also log in using it for a secure, passwordless experience. During checkout, you can sign in using either an OTP (sent to your email or phone) or your saved passkey.',
    },
    {
      question: 'What information can I save in my account?',
      answer:
        'You can securely save: Card payment methods (credit & debit cards only), Billing address & shipping address, Passkeys for faster login.',
    },
    {
      question: 'Can I use my saved cards and addresses across all merchants?',
      answer:
        'Yes. Your saved information works across all merchants that use Paymob Checkout. This means: You can pay instantly with your saved card. Your saved billing/shipping address can be autofilled when a merchant requests addresses.',
    },
    {
      question: 'How secure is Click by Paymob?',
      answer:
        'Click by Paymob ensures maximum security through: Tokenization & encryption for all card details, Passkeys (FIDO2 standard) for secure, passwordless login, PCI DSS compliance for handling sensitive payment data. 👉 Merchants never see your saved card or passkey information.',
    },
    {
      question: 'Can I manage or delete my saved information?',
      answer:
        "Yes, you have full control to: Delete or update saved cards, Delete or update saved addresses, Remove passkeys, Delete your entire account (after which you'll need to re-create it if you want to use again).",
    },
    {
      question: 'Do merchants have access to my saved information?',
      answer:
        'Cards → No, merchants never see your saved card details. Addresses → Only shared when you pay through a Payment Link that specifically asks for billing/shipping details.',
    },
    {
      question: 'Does using Click by Paymob cost extra?',
      answer:
        "No. There are no additional fees for using Click by Paymob. Transactions follow Paymob's standard pricing model.",
    },
  ];
  